import * as PhosphorIcons from '@phosphor-icons/react'
import { cn } from 'src/helpers/style'

export enum AppIconNames {
  arrowUp = 'arrow-up',
  arrowLeft = 'arrow-left',
  arrowRight = 'arrow-right',
  plus = 'plus',
  close = 'close',
  download = 'download',
  menu = 'menu',
  chevronDown = 'chevron-down',
  check = 'check',
  sparkle = 'sparkle',
  externalLink = 'external-link',
  rotate = 'rotate',
  signOut = 'sign-out',
  arrowsOut = 'arrows-out',
  arrowsIn = 'arrows-in',
  xLogo = 'x-logo',
  linkedinLogo = 'linkedin-logo',
  globe = 'globe',
}

const IconMap: Record<AppIconNames, PhosphorIcons.Icon> = {
  [AppIconNames.arrowUp]: PhosphorIcons.ArrowUpIcon,
  [AppIconNames.arrowLeft]: PhosphorIcons.ArrowLeftIcon,
  [AppIconNames.arrowRight]: PhosphorIcons.ArrowRightIcon,
  [AppIconNames.plus]: PhosphorIcons.PlusIcon,
  [AppIconNames.close]: PhosphorIcons.XIcon,
  [AppIconNames.download]: PhosphorIcons.DownloadSimpleIcon,
  [AppIconNames.menu]: PhosphorIcons.ListIcon,
  [AppIconNames.chevronDown]: PhosphorIcons.CaretDownIcon,
  [AppIconNames.check]: PhosphorIcons.CheckIcon,
  [AppIconNames.sparkle]: PhosphorIcons.SparkleIcon,
  [AppIconNames.externalLink]: PhosphorIcons.ArrowSquareOutIcon,
  [AppIconNames.rotate]: PhosphorIcons.ArrowCounterClockwiseIcon,
  [AppIconNames.signOut]: PhosphorIcons.SignOutIcon,
  [AppIconNames.arrowsOut]: PhosphorIcons.ArrowsOutSimpleIcon,
  [AppIconNames.arrowsIn]: PhosphorIcons.ArrowsInSimpleIcon,
  [AppIconNames.xLogo]: PhosphorIcons.XLogoIcon,
  [AppIconNames.linkedinLogo]: PhosphorIcons.LinkedinLogoIcon,
  [AppIconNames.globe]: PhosphorIcons.GlobeIcon,
}

export type AppIconProps = {
  name: AppIconNames
  disabled?: boolean
  alt?: string
  weight?: PhosphorIcons.IconProps['weight']
  size?: string | number
  color?: string
  mirrored?: boolean
} & React.ComponentProps<'svg'>

export const AppIcon = ({
  name,
  className,
  disabled = false,
  alt,
  weight = 'regular',
  size = 24,
  mirrored = false,
  color,
  ...props
}: AppIconProps) => {
  const Icon = IconMap[name]

  return (
    <Icon
      aria-label={alt}
      className={cn(disabled && 'opacity-50 grayscale', className)}
      weight={weight}
      size={size}
      mirrored={mirrored}
      color={color}
      {...(props as React.ComponentProps<typeof Icon>)}
    />
  )
}
